ALLOWED_CONTROLLER = 'ui_nodes'
ALLOWED_ACTIONS = ['index']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  $('*[data-selector="select_all_ui_nodes"]').on 'click', (e) ->
    $('[data-selector="ui_node_checkbox"]').prop('checked', $('[data-selector="select_all_ui_nodes"]').prop('checked'))

  $('*[data-selector="set_value_for"]').on 'change', (e) ->
    ids = []
    column_to_change = $(e.target).val()

    $('[data-selector="ui_node_checkbox"]').each (index, element) ->
      ids.push(element.id) if element.checked

    if ids.length > 0 && column_to_change != ''
      $("#ids").val(ids.join())
      $('#open-form-submit').click()
    else
      $('*[data-selector="set_value_for"]').val("")
      alert("First you have to select some Ui Nodes.")

$(document).ready(ready)
$(document).on('turbo:load', ready)

